import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { AttachmentCardStoreContext } from '../contexts/StoreContext'
import { AttachmentCardStore } from '../store/interface'

export const useAttachmentCardStore: UseStore<
  AttachmentCardStore
> = selector => {
  return useContextStore(AttachmentCardStoreContext, selector)
}

export const useAttachmentCardStoreApi = () => {
  return useContextStoreApi(AttachmentCardStoreContext)
}
